import { assert } from './assert.ts';

export function bisect_predicate_range(
  f: (x: number) => boolean,
  a: number,  // start of x range to explore
  b: number,  // end of x range to explore
  tolerance: number, // absolute tolerance,
): number {
  // Find x where f(x) flips from False to True
  // f(a) must be False
  // f(b) must be True
  // f should flip only once in the range a,b.

  let fa: boolean = f(a);
  let fb: boolean = f(b);

  while (Math.abs(b - a) >= tolerance) {
    if (fa) {
      throw new Error('f(a) must be False, but was True for a:' + a.toString());
    }

    if (!fb) {
      throw new Error('f(b) must be True, but was False for b:' + b.toString());
    }

    const c: number = (a + b) / 2;
    const fc: boolean = f(c);

    if (fc) {
      b = c;
      fb = f(b);
    } else {
      a = c;
      fa = f(a);
    }
  }

  return (a + b) / 2;
}

export function zip_equal_sized_arrays<T, U>(a: T[], b: U[]): Array<[T, U]> {
  assert(
    a.length === b.length,
    `a and b must be equal length, but instead have lengths ${a.length} and ${b.length}`,
  );

  return a.map((k, i) => [k, b[i]]);
}
